// src/routes/dashboardRoutes.tsx

import {
  Link,
  NavLink,
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Dashboard from "../components/Dashboard/Dashboard";
import MiCuenta from "../components/Dashboard/Layout/MiCuenta/MiCuenta";
import Facturacion from "../components/Dashboard/Layout/Facturacion/Facturacion";
import MisCompras from "../components/Dashboard/Layout/MisCompras/MisCompras";
import ControlVideos from "../components/Dashboard/Layout/Videos/ControlVideos";
import Configuracion from "../components/Dashboard/Layout/Configuracion/Configuracion";
import Reportes from "../components/Dashboard/Layout/Reportes/Reportes";
import ReportesController from "../resource/web/controllers/reportes/ReportesController";
import ReporteController from "../resource/web/controllers/reportes/ReporteController";
import EventosController from "../resource/web/controllers/eventos/EventosController";
import EventoController from "../resource/web/controllers/eventos/EventoController";
import BoleteriaController from "../resource/web/controllers/eventos/BoleteriaController";
import UsuariosController from "../resource/web/controllers/usuarios/UsuariosController";
import UsuarioController from "../resource/web/controllers/usuarios/UsuarioController";
import CuponesController from "../resource/web/controllers/eventos/CuponesController";
import CuponController from "../resource/web/controllers/eventos/CuponController";
import MembresiasController from "../resource/web/controllers/membresias/MembresiasController";
import Sidebar from "../resource/web/components/menu/Sidebar";
import NotasController from "../resource/web/controllers/notas/NotasController";
import NotaController from "../resource/web/controllers/notas/NotaController";
import VideosController from "../resource/web/controllers/videos/VideosController";
import PerfilController from "../resource/web/controllers/perfil/PerfilController";
import FacturacionController from "../resource/web/controllers/facturacion/FacturacionController";
import ConfiguracionesController from "../resource/web/controllers/configuraciones/ConfiguracionesController";
import MapaTeatroKonva from "../resource/web/page/mapa/MapaTeatroKonva";
import ProtectedRoute from "../middleware/ProtectedRoute";

const AdminRoutes = [
  <Route
    path="/dashboard/perfil"
    element={
      <ProtectedRoute>
        <Sidebar>
          <PerfilController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/cuentas"
    element={
      <ProtectedRoute>
        <Sidebar>
          <Reportes />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/facturacion"
    element={
      <ProtectedRoute>
        <Sidebar>
          <FacturacionController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/facturacion/:idEvento"
    element={
      <ProtectedRoute>
        <Sidebar>
          <Reportes />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/videos"
    element={
      <ProtectedRoute>
        <Sidebar>
          <VideosController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/configuracion"
    element={
      <ProtectedRoute>
        <Sidebar>
          <ConfiguracionesController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/facturacion"
    element={
      <ProtectedRoute>
        <Sidebar>
          <Reportes />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/reportes"
    element={
      <ProtectedRoute>
        <Sidebar>
          <ReportesController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/reportes/nuevo"
    element={
      <ProtectedRoute>
        <Sidebar>
          <ReporteController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/reportes/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <ReporteController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/reportes/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <ReporteController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,

  <Route
    path="/dashboard/eventos"
    element={
      <ProtectedRoute>
        <Sidebar>
          <EventosController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/eventos/crear"
    element={
      <ProtectedRoute>
        <Sidebar>
          <EventoController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/eventos/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <EventoController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/eventos/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <EventoController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,

  <Route
    path="/dashboard/boleteria/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <BoleteriaController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/boleteria/:id/:shared_token"
    element={
      <ProtectedRoute>
        <BoleteriaController />
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/usuarios"
    element={
      <ProtectedRoute>
        <Sidebar>
          <UsuariosController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/usuarios/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <UsuarioController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,

  <Route
    path="/dashboard/cupones"
    element={
      <ProtectedRoute>
        <Sidebar>
          <CuponesController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/cupones/nuevo"
    element={
      <ProtectedRoute>
        <Sidebar>
          <CuponController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/cupones/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <CuponController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/notas"
    element={
      <ProtectedRoute>
        <Sidebar>
          <NotasController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/nota/:id"
    element={
      <ProtectedRoute>
        <Sidebar>
          <NotaController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/membresias"
    element={
      <ProtectedRoute>
        <Sidebar>
          <MembresiasController />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
  <Route
    path="/dashboard/mapa"
    element={
      <ProtectedRoute>
        <Sidebar>
          <MapaTeatroKonva />
        </Sidebar>
      </ProtectedRoute>
    }
  />,
];

export default AdminRoutes;
